import * as React from "react";

export function useImage(src: string) {
	const [imageEl, setImageEl] = React.useState<HTMLImageElement>();

	React.useEffect(() => {
		const imageObj = new Image();
		imageObj.onload = () => {
			setImageEl(imageObj);
		};
		imageObj.src = src;
	}, [src]);

	return imageEl;
}
